import Logo from "@/components/app/Logo";
import { Link } from "react-router-dom";

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-[#F4F4F0]">
      <nav className="border-b-4 border-black px-6 py-4 flex items-center justify-between bg-[#F4F4F0]">
        <Link to="/"><Logo size={36} showText className="text-xl" /></Link>
      </nav>

      <div className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="font-heading text-4xl font-black tracking-tighter uppercase mb-8">Privacy Policy</h1>
        <div className="font-body text-sm leading-relaxed space-y-6 text-neutral-700">
          <p><strong>Last updated:</strong> April 13, 2026</p>

          <p>GrabOrSkip ("we", "us", "our") operates the graborskip.com website and mobile application (the "Service"). This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service.</p>

          <h2 className="font-heading text-xl font-bold uppercase mt-8">Information We Collect</h2>
          <p>When you create an account, we collect your name, email address, and phone number. When you use the scanning feature, we process photos you upload to identify items for resale analysis. Photos are processed in real-time and compressed thumbnails may be stored with your scan history.</p>

          <h2 className="font-heading text-xl font-bold uppercase mt-8">How We Use Your Information</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>To provide and maintain the Service</li>
            <li>To analyze thrift items using AI (Claude by Anthropic) for resale verdicts</li>
            <li>To search eBay for market pricing data related to your scanned items</li>
            <li>To track your hauls, inventory, and profit/loss</li>
            <li>To communicate with you about your account</li>
          </ul>

          <h2 className="font-heading text-xl font-bold uppercase mt-8">Third-Party Services</h2>
          <p>We use the following third-party services to provide our features:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Anthropic (Claude AI)</strong> — Image analysis for item identification. Photos are sent to Anthropic's API for processing.</li>
            <li><strong>eBay APIs</strong> — Market data lookup and optional listing creation on your behalf (requires your explicit authorization via eBay OAuth).</li>
            <li><strong>SerpApi</strong> — Sold listing data for pricing accuracy.</li>
          </ul>

          <h2 className="font-heading text-xl font-bold uppercase mt-8">eBay Account Connection</h2>
          <p>If you choose to connect your eBay account for listing items, we access your eBay selling capabilities through eBay's official OAuth2 authorization. You can revoke this access at any time through your eBay account settings. We only use this access to create listings on your behalf when you explicitly request it.</p>

          <h2 className="font-heading text-xl font-bold uppercase mt-8">Data Storage & Security</h2>
          <p>Your data is stored securely in our database. Passwords are hashed using bcrypt. Authentication uses HTTP-only secure cookies. We do not sell your personal information to third parties.</p>

          <h2 className="font-heading text-xl font-bold uppercase mt-8">Data Deletion</h2>
          <p>You may request deletion of your account and all associated data by contacting us. If you connected an eBay account, we will also delete any stored eBay tokens.</p>

          <h2 className="font-heading text-xl font-bold uppercase mt-8">Contact</h2>
          <p>For questions about this privacy policy, contact us at privacy@graborskip.com.</p>
        </div>
      </div>
    </div>
  );
}
